import { Color, RGBColor } from "./colors"
import { AttackType, ItemType, PaletteColor } from "./enums"
import { Symbol } from "./symbols"

export const Points = {
  MAX_ENEMY_DAMAGE: 1000,
}

export const DBDefaults = {
  KEY_PLAYER: "tapestry_player",
  KEY_TAPESTRY: "tapestry_tapestry",
}

export const EnemyDefaults = {
  FOV: 5,
  ITEM_DROP_PROB: 0.25,
  ESSENCE_DROP_MIN: 1,
  ESSENCE_DROP_MAX: 3,
  PIGMENT_DROP_MIN: 1,
  PIGMENT_DROP_MAX: 5,
  MIN_FOV_RANGE: 10,
  MAX_FOV_RANGE: 14,
}

export const EngineDefaults = {
  DISPLAY_OFFSETS: {
    xOffset: 1,
    yOffset: 0,
  },
  UPDATE_FREQ: 500,
  WIDTH: 80,
  MESSAGES_HEIGHT: 5,
  GAME_HEIGHT: 30,
  STATS_HEIGHT: 5,
  TROPHY_CASE_WIDTH: 78,
  TROPHY_CASE_HEIGHT: 30,
}

export const ItemDefaults = {
  MAX_RANDOM_ITEM_PLACEMENT_TRIES: 100,
  ELIXIR_HEAL: 1,
}

export const CollectibleProbability = {
  COMMON: 0.2,
  MYTHIC: 0.025,
}

export const MapDefaults = {
  CORRIDOR_LENGTH: 6,
}

export const Pigments = [
  PaletteColor.RED,
  PaletteColor.BLUE,
  PaletteColor.GREEN,
  PaletteColor.YELLOW,
  PaletteColor.MAGENTA,
  PaletteColor.CYAN,
]

// Max length of equipment name -> 23
export const EquipmentDefaults = {
  NONE: {
    type: ItemType.NONE,
    name: "NONE",
    equipped: false,
    twoHanded: false,
    minEssenceAttack: 0,
    maxEssenceAttack: 0,
    essenceDefense: 0,
    minPigmentAttack: 0,
    maxPigmentAttack: 0,
    pigmentDefense: 0,
    stealthRange: 0,
  },
  HEAD: {
    HEAD_NONE: {
      type: ItemType.EQUIPMENT_HEAD_NONE,
      name: "none",
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 0,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 0,
    },
    HEAD1: {
      type: ItemType.EQUIPMENT_HEAD1,
      name: "Trader Cloth Hat", // length = 16, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 0,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 3,
      stealthRange: 2,
    },
    HEAD2: {
      type: ItemType.EQUIPMENT_HEAD2,
      name: "Trader Leather Hat", // length = 18, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 1,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 2,
      stealthRange: 1,
    },
    HEAD3: {
      type: ItemType.EQUIPMENT_HEAD3,
      name: "Explorer Cloth Hood", // length = 19, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 2,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 0,
    },
    HEAD4: {
      type: ItemType.EQUIPMENT_HEAD4,
      name: "Explorer Leather Hood", // length = 21, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 2,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 1,
      stealthRange: 0,
    },
    HEAD5: {
      type: ItemType.EQUIPMENT_HEAD5,
      name: "Mender Cap", // length = 10, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 0,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 4,
      stealthRange: 0,
    },
    HEAD6: {
      type: ItemType.EQUIPMENT_HEAD6,
      name: "Mender Curing Cap", // length = 17, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 1,
      maxEssenceAttack: 1,
      essenceDefense: 2,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 4,
      stealthRange: 0,
    },
    HEAD7: {
      type: ItemType.EQUIPMENT_HEAD7,
      name: "Reviver Fez", // length = 11, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 1,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 3,
      stealthRange: 2,
    },
    HEAD8: {
      type: ItemType.EQUIPMENT_HEAD8,
      name: "Fez of Finality", // length = 15, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 1,
      maxEssenceAttack: 1,
      essenceDefense: 1,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 4,
      stealthRange: 3,
    },
  },
  TORSO: {
    TORSO_NONE: {
      type: ItemType.EQUIPMENT_TORSO_NONE,
      name: "none",
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 0,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 0,
    },
    TORSO1: {
      type: ItemType.EQUIPMENT_TORSO1,
      name: "Trader Cloth Robe", // length = 17, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 2,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 2,
    },
    TORSO2: {
      type: ItemType.EQUIPMENT_TORSO2,
      name: "Trader Leather Vest", // length = 19, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 3,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 1,
      stealthRange: 2,
    },
    TORSO3: {
      type: ItemType.EQUIPMENT_TORSO3,
      name: "Explorer Cloth Cloak", // length = 20, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 4,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 0,
    },
    TORSO4: {
      type: ItemType.EQUIPMENT_TORSO4,
      name: "Explorer Leather Cloak", // length = 22, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 5,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: -1,
    },
    TORSO5: {
      type: ItemType.EQUIPMENT_TORSO5,
      name: "Mender Robe", // length = 11, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 3,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 3,
      stealthRange: 0,
    },
    TORSO6: {
      type: ItemType.EQUIPMENT_TORSO6,
      name: "Mender Repair Robe", // length = 18, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 1,
      maxEssenceAttack: 1,
      essenceDefense: 3,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 3,
      stealthRange: 2,
    },
    TORSO7: {
      type: ItemType.EQUIPMENT_TORSO7,
      name: "Reviver Tunic", // length = 13, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 4,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 3,
      stealthRange: 4,
    },
    TORSO8: {
      type: ItemType.EQUIPMENT_TORSO8,
      name: "Tunic of Terminus", // length = 17, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 1,
      maxEssenceAttack: 1,
      essenceDefense: 4,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 2,
      stealthRange: 5,
    },
  },
  FEET: {
    FEET_NONE: {
      type: ItemType.EQUIPMENT_FEET_NONE,
      name: "none",
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 0,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 0,
    },
    FEET1: {
      type: ItemType.EQUIPMENT_FEET1,
      name: "Trader Sandals", // length = 14, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 0,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 5,
    },
    FEET2: {
      type: ItemType.EQUIPMENT_FEET2,
      name: "Trader Cloth Slippers", // length = 21, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 0,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 6,
    },
    FEET3: {
      type: ItemType.EQUIPMENT_FEET3,
      name: "Explorer Moccasins", // length = 18, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 1,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 0,
    },
    FEET4: {
      type: ItemType.EQUIPMENT_FEET4,
      name: "Explorer Chukkas", // length = 16, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 2,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 2,
      stealthRange: -2,
    },
    FEET5: {
      type: ItemType.EQUIPMENT_FEET5,
      name: "Mender Boots", // length = 20, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 0,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 2,
      stealthRange: 3,
    },
    FEET6: {
      type: ItemType.EQUIPMENT_FEET6,
      name: "Mender Better Boots", // length = 19, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 1,
      maxEssenceAttack: 1,
      essenceDefense: 1,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 2,
      stealthRange: 4,
    },
    FEET7: {
      type: ItemType.EQUIPMENT_FEET7,
      name: "Reviver Clogs", // length = 13, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 3,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 2,
      stealthRange: 1,
    },
    FEET8: {
      type: ItemType.EQUIPMENT_FEET8,
      name: "Clogs of Conclusion", // length = 19, OK
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 1,
      maxEssenceAttack: 1,
      essenceDefense: 3,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 2,
      stealthRange: 1,
    },
  },
  GIZMO: {
    GIZMO_NONE: {
      type: ItemType.EQUIPMENT_GIZMO_NONE,
      name: "none",
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 0,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 0,
    },
    GIZMO1: {
      type: ItemType.EQUIPMENT_GIZMO1,
      name: "Escape Rope",
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 0,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 0,
    },
    GIZMO2: {
      type: ItemType.EQUIPMENT_GIZMO2,
      name: "Map Scanner",
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 0,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 0,
    },
    GIZMO3: {
      type: ItemType.EQUIPMENT_GIZMO3,
      name: "Polychrome Optic",
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 0,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 0,
    },
    GIZMO4: {
      type: ItemType.EQUIPMENT_GIZMO4,
      name: "Ring of Invincibility",
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 0,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 0,
    },
    GIZMO5: {
      type: ItemType.EQUIPMENT_GIZMO5,
      name: "Anti-theft Charm",
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 0,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 0,
    },
  },
  WEAPON: {
    WEAPON_NONE: {
      type: ItemType.EQUIPMENT_WEAPON_NONE,
      name: "none",
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 0,
      maxEssenceAttack: 0,
      essenceDefense: 0,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 0,
    },
    WEAPON1: {
      type: ItemType.EQUIPMENT_WEAPON1,
      name: "Knife",
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 1,
      maxEssenceAttack: 1,
      essenceDefense: 0,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 0,
    },
    WEAPON2: {
      type: ItemType.EQUIPMENT_WEAPON2,
      name: "Dagger",
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 1,
      maxEssenceAttack: 2,
      essenceDefense: 0,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 0,
    },
    WEAPON3: {
      type: ItemType.EQUIPMENT_WEAPON3,
      name: "Scimitar",
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 2,
      maxEssenceAttack: 4,
      essenceDefense: 0,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 0,
    },
    WEAPON4: {
      type: ItemType.EQUIPMENT_WEAPON4,
      name: "Rapier",
      equipped: false,
      twoHanded: false,
      minEssenceAttack: 2,
      maxEssenceAttack: 6,
      essenceDefense: 0,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 0,
    },
    WEAPON5: {
      type: ItemType.EQUIPMENT_WEAPON5,
      name: "Spear",
      equipped: false,
      twoHanded: true,
      minEssenceAttack: 4,
      maxEssenceAttack: 6,
      essenceDefense: 0,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 0,
    },
    WEAPON6: {
      type: ItemType.EQUIPMENT_WEAPON6,
      name: "Glaive",
      equipped: false,
      twoHanded: true,
      minEssenceAttack: 4,
      maxEssenceAttack: 8,
      essenceDefense: 0,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 0,
    },
    WEAPON7: {
      type: ItemType.EQUIPMENT_WEAPON7,
      name: "Great Axe",
      equipped: false,
      twoHanded: true,
      minEssenceAttack: 6,
      maxEssenceAttack: 10,
      essenceDefense: 0,
      minPigmentAttack: 0,
      maxPigmentAttack: 0,
      pigmentDefense: 0,
      stealthRange: 0,
    },
  },
}

export const GizmoDefaults = {
  GIZMO3: {
    // Polychrome Optic
    ACTIVE: 500, // milliseconds
    COOLDOWN: 15000, // milliseconds
  },
  GIZMO4: {
    // Ring of Invincibility
    ACTIVE: 1000, // milliseconds
    COOLDOWN: 8000, // milliseconds
  },
  GIZMO5: {
    ACTIVE: 1000, // milliseconds
    COOLDOWN: 3000, // milliseconds
  },
}

export const TapestryDefaults = {
  MUSIC: { source: "01 Tapestry.ogg", title: "Tapestry [needs title]" },
  PIGMENT_PER_BIND: 40,
  TILES_PER_BIND: 5,
  PIGMENT_BUMP: 1.0,
  BLINK_GROUPS: 2,
  BLINK_SYMBOL: "*",
  BLINK_COLORS: [
    RGBColor.WHITE,
    RGBColor.RED,
    RGBColor.BLUE,
    RGBColor.GREEN,
    RGBColor.YELLOW,
    RGBColor.MAGENTA,
    RGBColor.CYAN,
  ],
}

export const PIGMENT_DROP = 5

export const PlayerDefaults = {
  MAX_STAT: 10,
  MAX_ELIXIRS: 10,
  MAX_ESSENCE: 100,
  MAX_LEVEL: 10,
  MAX_PIGMENT: 100,
  MAX_PIGMENT_CHARS: 3,
  MAX_BINDER_CHARS: 3,

  STEALTH_MODIFIER: 0.8,

  ELIXIR_HEALING: 3,

  YELLOW_THRESHHOLD: 100,
  MAGENTA_THRESHHOLD: 100,
  RED_THRESHHOLD: 100,
  BLUE_THRESHHOLD: 100,
  CYAN_THRESHHOLD: 100,
  GREEN_THRESHHOLD: 100,

  COMBAT: {
    LEVEL1: {
      essence: 15,
      maxEssence: 15,
      essenceDefense: 0,
      pigmentDefense: 0,
      stealthRange: 0,
      minAttack: 1,
      maxAttack: 1,
      attackType: AttackType.DRAIN_ESSENCE,
      attackMessage: "drain essence",
    },
    LEVEL2: {
      essence: 17,
      maxEssence: 17,
      essenceDefense: 0,
      pigmentDefense: 0,
      stealthRange: 0,
      minAttack: 1,
      maxAttack: 1,
      attackType: AttackType.DRAIN_ESSENCE,
      attackMessage: "drain essence",
    },
    LEVEL3: {
      essence: 18,
      maxEssence: 18,
      essenceDefense: 0,
      pigmentDefense: 0,
      stealthRange: 0,
      minAttack: 1,
      maxAttack: 1,
      attackType: AttackType.DRAIN_ESSENCE,
      attackMessage: "drain essence",
    },
    LEVEL4: {
      essence: 20,
      maxEssence: 20,
      essenceDefense: 0,
      pigmentDefense: 0,
      stealthRange: 0,
      minAttack: 1,
      maxAttack: 2,
      attackType: AttackType.DRAIN_ESSENCE,
      attackMessage: "drain essence",
    },
    LEVEL5: {
      essence: 22,
      maxEssence: 22,
      essenceDefense: 0,
      pigmentDefense: 0,
      stealthRange: 0,
      minAttack: 2,
      maxAttack: 2,
      attackType: AttackType.DRAIN_ESSENCE,
      attackMessage: "drain essence",
    },
    LEVEL6: {
      essence: 24,
      maxEssence: 24,
      essenceDefense: 0,
      pigmentDefense: 0,
      stealthRange: 0,
      minAttack: 2,
      maxAttack: 2,
      attackType: AttackType.DRAIN_ESSENCE,
      attackMessage: "drain essence",
    },
    LEVEL7: {
      essence: 25,
      maxEssence: 25,
      essenceDefense: 0,
      pigmentDefense: 0,
      stealthRange: 0,
      minAttack: 2,
      maxAttack: 3,
      attackType: AttackType.DRAIN_ESSENCE,
      attackMessage: "drain essence",
    },
    LEVEL8: {
      essence: 27,
      maxEssence: 27,
      essenceDefense: 0,
      pigmentDefense: 0,
      stealthRange: 0,
      minAttack: 2,
      maxAttack: 4,
      attackType: AttackType.DRAIN_ESSENCE,
      attackMessage: "drain essence",
    },
    LEVEL9: {
      essence: 29,
      maxEssence: 29,
      essenceDefense: 0,
      pigmentDefense: 0,
      stealthRange: 0,
      minAttack: 2,
      maxAttack: 4,
      attackType: AttackType.DRAIN_ESSENCE,
      attackMessage: "drain essence",
    },
    LEVEL10: {
      essence: 30,
      maxEssence: 30,
      essenceDefense: 0,
      pigmentDefense: 0,
      stealthRange: 0,
      minAttack: 3,
      maxAttack: 5,
      attackType: AttackType.DRAIN_ESSENCE,
      attackMessage: "drain essence",
    },
  },

  EXP_LEVEL2: 300,
  EXP_LEVEL3: 750,
  EXP_LEVEL4: 1425,
  EXP_LEVEL5: 2450,
  EXP_LEVEL6: 4000,
  EXP_LEVEL7: 6250,
  EXP_LEVEL8: 9700,
  EXP_LEVEL9: 15000,
  EXP_LEVEL10: 22500,

  RENDER: {
    symbol: [Symbol.PLAYER],
    light: Color.PLAYER_NORMAL,
    dark: Color.PLAYER_NORMAL,
  },
  START_ELIXIRS: 1,
  START_VISION: 4,
  START_BINDER: 0,
  START_BINDERS_COLLECTED: {
    jan: 0,
    feb: 0,
    mar: 0,
    apr: 0,
    may: 0,
    jun: 0,
    jul: 0,
    aug: 0,
    sep: 0,
    oct: 0,
    nov: 0,
    dec: 0,
  },
}

export const CollectiblesDefaults = {
  COLLECTIBLES_COLUMNS: 4,
  COLLECTIBLES_ROWS: 3,
  PADDING_TOP: 3,
  PADDING_LEFT: 5,
  CUBBIE_COL_SPACING: 5,
  CUBBIE_WIDTH: 13,
  CUBBIE_ROW_SPACING: 3,
  CUBBIE_HEIGHT: 6,
  MIN_REQ_LEVEL: 1,
}

export const Paths = {
  MUSIC: "music/",
}

export const Dims = {
  DEFAULT_VIEWPORT_WIDTH: 80,
  DEFAULT_VIEWPORT_HEIGHT: 30,
  MAX_VIEWPORT_HEIGHT: 30,
  MAX_VIEWPORT_WIDTH: 80,
  DEFAULT_DYNAMIC_MAP_WIDTH: 160,
  DEFAULT_DYNAMIC_MAP_HEIGHT: 40,
}

export const EnemyDescriptions = {
  RIFT_ESSENCE: "immobile; drain essence",
  RIFT_PIGMENT: "immobile; drain pigment",
  RIFT_BOTH: "immobile; drain essence+pigment",
  SPECTRE_ESSENCE: "chase, sync; drain essence",
  SPECTRE_PIGMENT: "chase, sync; drain pigment",
  SPECTRE_BOTH: "chase, sync; drain essence+pigment",
  REAVER_ESSENCE: "chase, auto; drain essence",
  REAVER_PIGMENT: "chase, auto; drain pigment",
  REAVER_BOTH: "chase, auto; drain essence+pigment",
  BLADE_ESSENCE: "bounce, auto; drain essence",
  BLADE_PIGMENT: "bounce, auto; drain pigment",
  BLADE_BOTH: "bounce, auto; drain essence+pigment",
  VOID_ESSENCE: "bounce, sync; drain essence",
  VOID_PIGMENT: "bounce, sync; drain pigment",
  VOID_BOTH: "bounce, sync; drain essence+pigment",
  DEVOURER: "immobile; drain all essence",
}
